import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ListTree, FileText, BarChart3 } from "lucide-react";
import type { VisualSeed, VisualNode } from "@/hooks/useMapVisualData";
import { BriefCards } from "./BriefCards";
import { ArticleList } from "./ArticleList";
import { PipelineOverview } from "./PipelineOverview";

interface ContentBrowserProps {
  seeds: VisualSeed[];
  nodes: VisualNode[];
}

export function ContentBrowser({ seeds, nodes }: ContentBrowserProps) {
  const briefCount = nodes.filter(n => n.outline && n.outline.length > 0).length;
  const readyCount = nodes.filter(n => n.final_html && ["ready", "published"].includes(n.engine_stage || "")).length;

  return (
    <Tabs defaultValue="briefs" className="space-y-3">
      <TabsList>
        <TabsTrigger value="briefs" className="gap-1.5">
          <ListTree className="h-3.5 w-3.5" /> Briefy ({briefCount})
        </TabsTrigger>
        <TabsTrigger value="articles" className="gap-1.5">
          <FileText className="h-3.5 w-3.5" /> Artykuly ({readyCount})
        </TabsTrigger>
        <TabsTrigger value="pipeline" className="gap-1.5">
          <BarChart3 className="h-3.5 w-3.5" /> Pipeline
        </TabsTrigger>
      </TabsList>

      <TabsContent value="briefs">
        <BriefCards seeds={seeds} nodes={nodes} />
      </TabsContent>

      <TabsContent value="articles">
        <ArticleList seeds={seeds} nodes={nodes} />
      </TabsContent>

      <TabsContent value="pipeline">
        <PipelineOverview seeds={seeds} nodes={nodes} />
      </TabsContent>
    </Tabs>
  );
}
